import React from 'react'
import Text from '../Text'
import useAutoScrollCards from '../../hooks/useAutoScrollCards'
const HelpSection = ({ data }) => {
  const title = data?.title
  const description = data?.description
  const cards = Array.isArray(data?.points) ? data.points : []
  const image = data?.image
  const { scrollContainerRef } = useAutoScrollCards({ cards })
  return (
    <section className="w-full bg-white">
      <div className="max-w-[1024px] mx-auto px-4">
        <div className="flex flex-col items-center text-center gap-4">
          {title ? (
            <Text
              variant="headline"
              size="small"
              tag="p"
              className="text-[#0F172A]"
            >
              {title}
            </Text>
          ) : null}
          {image ? (
            <div className="">
              <img
                src={image}
                alt={title || 'Benefits'}
                className="w-full h-[183px] mx-auto object-scale-down"
              />
            </div>
          ) : null}
          {description ? (
            <Text
              variant="body"
              size="medium"
              tag="p"
              className="text-[#475569]"
            >
              {description}
            </Text>
          ) : null}
        </div>

        {cards.length ? (
          <div
            ref={scrollContainerRef}
            className="mt-8 flex gap-4 overflow-x-auto no-scrollbar -mx-4"
          >
            {cards.map((card, idx) => (
              <div
                key={`point-${idx + 1}`}
                data-card
                className="min-w-fit rounded-xl border border-[#E2E8F0] px-3 py-2 bg-white first:ml-4 last:mr-4"
              >
                <div className="min-w-fit flex items-center gap-3 flex-1">
                  {card?.icon ? (
                    <img
                      src={card?.icon}
                      alt={card?.text}
                      className="w-8 h-8 object-scale-down"
                    />
                  ) : null}
                  <Text
                    variant="body"
                    size="medium"
                    tag="p"
                    className="text-[#1C1C1C]"
                  >
                    {card?.text}
                  </Text>
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  )
}

export default HelpSection
